import token from 'styled-token';
import { hexToAlpha } from '../util/hexToAlpha';

/** @mixin alphaMixin */
/**
 * Applies an alpha value to one of the Constellation colors, returns the value in `rgba()` format
 *
 * @example
 * import { alphaMixin } from '@zillow/constellation';
 *
 * const Component = styled.div`
 *     color: ${alphaMixin('caution', 0.5)};
 * `;
 *
 * <Component />
 *
 * @method
 * @param {string} key - Key should be one of the values defined in `colors`.
 * @param alpha - Alpha value should be an integer in [0,255], a float in [0,1],
 *     or a 1 to 2 character hex value in the [0,255] range.
 * @return {CSSObject}
 */
export var alphaMixin = function alphaMixin(key, alpha) {
  return token('colors', function (colors) {
    var toParse = colors[key];
    if (!toParse || typeof toParse !== 'string') {
      throw new Error("Unknown color '" + key + "'");
    }
    return hexToAlpha(toParse, alpha);
  });
};